module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/content__vr-57b41d0bad24851cd86b1eb09e6c0f20.jpg";